/**
 * AdminRoute — wraps admin pages, redirects to /admin/login if not authenticated.
 * Optionally enforces a minimum role.
 */
import { Navigate, useLocation } from "react-router-dom";
import { useAdmin } from "../../context/AdminAuthContext";
import { hasRole } from "../../lib/adminApi";

export default function AdminRoute({ children, minRole = "reader" }) {
  const { admin, loading } = useAdmin();
  const location = useLocation();

  if (loading) {
    // Quiet placeholder — no flash. AdminAuthContext's fast-path means this
    // branch only renders during a genuine in-flight admin/me request.
    return <div className="fixed inset-0 bg-[#E4E4E4]" aria-hidden="true" />;
  }

  if (!admin) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  if (!hasRole(admin, minRole)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6] px-6">
        <div className="max-w-md text-center">
          <div className="text-5xl mb-4">🚫</div>
          <h2 className="font-amiri text-2xl text-[#0A192F] mb-2">صلاحياتك غير كافية</h2>
          <p className="text-[#4A4A4A] text-sm">
            هذه الصفحة تتطلّب صلاحية أعلى من صلاحيتك الحالية.
          </p>
        </div>
      </div>
    );
  }

  return children;
}
